// extracted by mini-css-extract-plugin
export var aiStarSpin = "_nf-1";
export var spinner = "_nf-0";